module.exports = "https://www.gc-qa.gnp.com.mx/046407e785bca02410e2a3333847bad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/creditCardG.png
// module id = 8090
// module chunks = 0